
  (function () {
    // -----------------------------------------------------------------------
    // BUY NOW: require all custom options + clear cart -> add -> drawer checkout
    // Paste at the bottom of theme.liquid, before </body>.
    // Works without touching any other theme file.
    // -----------------------------------------------------------------------
    if (window.__tmcBuyNowInstalled) return;
    window.__tmcBuyNowInstalled = true;

    var REQUIRED_TRUE = ['true', '1', 'yes'];
    function isRequired(el) {
      return REQUIRED_TRUE.indexOf(
        String(el.dataset.required || '').toLowerCase().replace(/"/g, '').trim()
      ) !== -1;
    }

    // ---- 1. Validation -----------------------------------------------------
    function validateFormOptions(form, applyFeedback) {
      var isValid = true;
      var firstInvalid = null;

      function mark(container, errorEl, focusTarget) {
        isValid = false;
        if (!applyFeedback) return;
        if (container) container.classList.add('is-invalid');
        if (errorEl) errorEl.hidden = false;
        if (!firstInvalid && focusTarget) firstInvalid = focusTarget;
      }

      // Charm pickers
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-charm-picker]'),
        function (picker) {
          if (!picker.offsetParent) return;
          var valueInput = picker.querySelector('[data-charm-value]');
          if (isRequired(picker) && valueInput && !valueInput.value.trim())
            mark(picker, picker.querySelector('[data-error]'), picker.querySelector('.product-charm-picker__trigger'));
        }
      );

      // Custom text configs
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-custom-text-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var hidden = cfg.querySelector('[data-text-value]');
          if (isRequired(cfg) && hidden && !(hidden.value || '').trim())
            mark(cfg, cfg.querySelector('[data-text-error]'), cfg.querySelector('[data-text-input]'));
        }
      );

      // Radio groups
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-radio-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var radios = cfg.querySelectorAll('[data-radio-input]');
          if (!radios.length) return;
          if (isRequired(cfg) && !cfg.querySelector('[data-radio-input]:checked'))
            mark(cfg, cfg.querySelector('[data-radio-error]'), radios[0]);
        }
      );

      // Add-on checkboxes (checked => their required fields must be filled)
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-addon-checkbox-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var checkbox = cfg.querySelector('[data-addon-checkbox]');
          if (!checkbox || !checkbox.checked) return;

          Array.prototype.forEach.call(cfg.querySelectorAll('[data-ga-field]'), function (field) {
            if (field.dataset.gaRequired !== 'true') return;
            var input = field.querySelector('[data-ga-field-input]');
            if (!input || !input.value.trim())
              mark(field, field.querySelector('[data-ga-field-error]'), input);
          });

          if (cfg.dataset.enableText === 'true') {
            var ti = cfg.querySelector('[data-addon-text-input]');
            if (!ti || !ti.value.trim())
              mark(cfg, cfg.querySelector('[data-addon-text-error]'), ti);
          }
        }
      );

      // Color dropdowns (a color maps to a child variant to add)
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-color-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var sel = cfg.querySelector('[data-color-select]');
          if (!sel) return;
          if (isRequired(cfg) && !sel.value.trim())
            mark(cfg, cfg.querySelector('[data-color-error]'), sel);
        }
      );

      // Image uploads
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-image-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var input = cfg.querySelector('[data-image-input]');
          if (!input) return;
          if (isRequired(cfg) && (!input.files || input.files.length === 0))
            mark(cfg, cfg.querySelector('[data-image-error]'), input);
        }
      );

      // Branch splits (dropdown or radio revealing one branch)
      Array.prototype.forEach.call(
        form.querySelectorAll('[data-branch-split]'),
        function (split) {
          if (!split.offsetParent) return;
          var sel = split.querySelector('[data-branch-select]');
          var radios = split.querySelectorAll('[data-branch-radio]');
          var isRadio = radios.length > 0;
          if (!sel && !isRadio) return;
          var has = isRadio
            ? Array.prototype.some.call(radios, function (r) { return r.checked; })
            : !!(sel && sel.value.trim());
          if (isRequired(split) && !has)
            mark(split, split.querySelector('[data-branch-select-error]'), isRadio ? radios[0] : sel);
        }
      );

      return { isValid: isValid, firstInvalid: firstInvalid };
    }

    // ---- 2. Collect child add-on / charm / color variants ------------------
    function collectChildItems(form, parentLineKey) {
      var items = [];
      var refBase = Date.now().toString(36);
      var seq = 0;
      var parentVariantId = parentLineKey ? String(parentLineKey).split(':')[0] : '';

      function link(item) {
        if (parentLineKey && String(item.id) !== parentVariantId) item.parent_line_key = parentLineKey;
        return item;
      }
      function withRef(item) {
        item.properties = Object.assign({}, item.properties, { _ref: refBase + '-' + (seq++) });
        return item;
      }

      Array.prototype.forEach.call(
        form.querySelectorAll('[data-addon-checkbox-config]'),
        function (cfg) {
          if (!cfg.offsetParent || cfg.dataset.available === 'false') return;
          var checkbox = cfg.querySelector('[data-addon-checkbox]');
          if (!checkbox || !checkbox.checked) return;
          var variantId = cfg.dataset.variantId;
          if (!variantId) return;
          var item = link({ id: parseInt(variantId, 10), quantity: 1 });
          var props = {};
          var ti = cfg.querySelector('[data-addon-text-input]');
          if (ti && ti.value.trim()) props[ti.dataset.addonTextLabel || 'Custom Text'] = ti.value.trim();
          Array.prototype.forEach.call(cfg.querySelectorAll('[data-ga-field]'), function (field) {
            var input = field.querySelector('[data-ga-field-input]');
            if (input && input.value.trim()) props[field.dataset.gaLabel || 'Text'] = input.value.trim();
          });
          if (Object.keys(props).length) item.properties = props;
          items.push(withRef(item));
        }
      );

      Array.prototype.forEach.call(
        form.querySelectorAll('[data-charm-picker]'),
        function (picker) {
          if (!picker.offsetParent) return;
          var variantId = picker.dataset.selectedVariantId;
          if (!variantId) return;
          var item = link({ id: parseInt(variantId, 10), quantity: 1 });
          var vi = picker.querySelector('[data-charm-value]');
          var name = vi ? vi.value.trim() : '';
          if (name) item.properties = Object.assign(item.properties || {},
            (function () { var o = {}; o[picker.dataset.charmLabel || 'Charm'] = name; return o; })());
          items.push(withRef(item));
        }
      );

      Array.prototype.forEach.call(
        form.querySelectorAll('[data-color-config]'),
        function (cfg) {
          if (!cfg.offsetParent) return;
          var sel = cfg.querySelector('[data-color-select]');
          if (!sel || !sel.value.trim()) return;
          var opt = sel.selectedOptions && sel.selectedOptions[0];
          var variantId = opt ? opt.dataset.variantId : '';
          if (variantId) items.push(withRef(link({ id: parseInt(variantId, 10), quantity: 1 })));
        }
      );

      Array.prototype.forEach.call(
        form.querySelectorAll('[data-auto-add-config]'),
        function (cfg) {
          var branchSec = cfg.closest('[data-branch-section]');
          if (branchSec && (branchSec.hidden || branchSec.disabled)) return;
          Array.prototype.forEach.call(cfg.querySelectorAll('[data-auto-add-variant]'), function (el) {
            if (el.dataset.available === 'false') return;
            var vid = el.dataset.autoAddVariant;
            if (vid) items.push(withRef(link({ id: parseInt(vid, 10), quantity: 1 })));
          });
        }
      );

      return items;
    }

    // ---- 3. Button loading state -------------------------------------------
    function setLoading(form, submitter, on) {
      Array.prototype.forEach.call(
        form.querySelectorAll('button[type="submit"], input[type="submit"], [is="loader-button"]'),
        function (btn) {
          if (on) btn.setAttribute('disabled', 'disabled');
          else btn.removeAttribute('disabled');
        }
      );
      if (submitter) {
        if (on) submitter.setAttribute('aria-busy', 'true');
        else submitter.removeAttribute('aria-busy');
        Array.prototype.forEach.call(
          submitter.querySelectorAll('.loader-button__loader'),
          function (spinner) { spinner.hidden = !on; if (on) spinner.removeAttribute('hidden'); }
        );
      }
    }

  // ---- Keep Buy Now clickable, but visually grey when incomplete -------------
// ---- Buy Now disabled + grey until all required options are selected ----
// ---- Buy Now disabled + grey until all required options are selected ----
function syncButton(form) {
  var btn = form.querySelector(
    '.product-form__buy-now-button[data-open-cart-drawer="true"]'
  );

  if (!btn || btn.dataset.tmcLoading === 'true') return;

  var res = validateFormOptions(form, false);

  if (res.isValid) {
    // VALID -> normal + clickable
    btn.classList.remove('tmc-buy-now-incomplete');
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
  } else {
    // INVALID -> grey + NOT clickable
    btn.classList.add('tmc-buy-now-incomplete');
    btn.setAttribute('disabled', 'disabled');
    btn.setAttribute('aria-disabled', 'true');
  }
}


// ---- Buy Now: clear cart -> add parent -> add children -> open cart drawer --
async function doBuyNow(form, submitter) {
  var routes =
    (window.themeVariables && window.themeVariables.routes) || {};

  var cartAddUrl = (routes.cartAddUrl || '/cart/add') + '.js';
  var cartUrl = (routes.cartUrl || '/cart') + '.js';
  var clearUrl = (routes.cartClearUrl || '/cart/clear') + '.js';

  submitter.dataset.tmcLoading = 'true';
  setLoading(form, submitter, true);

  try {
    // -------------------------------------------------------------------------
    // 1. CLEAR EXISTING CART
    // -------------------------------------------------------------------------
    var clearRes = await fetch(clearUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!clearRes.ok) {
      throw new Error('Failed to clear cart');
    }


    // -------------------------------------------------------------------------
    // 2. ADD MAIN / PARENT PRODUCT
    // -------------------------------------------------------------------------
    // FormData keeps:
    // - selected variant
    // - quantity
    // - properties
    // - uploaded files
    // -------------------------------------------------------------------------
    var fd = new FormData(form);

    // Remove Shopify option fields because variant ID is sufficient
    ['option1', 'option2', 'option3'].forEach(function (option) {
      fd.delete(option);
    });

    var idInput = form.querySelector('[name="id"]');

    if (idInput && idInput.value) {
      fd.set('id', idInput.value);
    }

    var parentRes = await fetch(cartAddUrl, {
      method: 'POST',
      body: fd,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!parentRes.ok) {
      throw new Error('Parent product add failed');
    }

    var parentData = await parentRes.json();

    var parentKey =
      (parentData.items &&
        parentData.items[0] &&
        parentData.items[0].key) ||
      parentData.key ||
      '';


    // -------------------------------------------------------------------------
    // 3. COLLECT + ADD CHILD PRODUCTS
    // -------------------------------------------------------------------------
    // This uses your existing collectChildItems() function.
    //
    // It includes:
    // - charms
    // - add-ons
    // - color variants
    // - auto-added variants
    // -------------------------------------------------------------------------
    var children = collectChildItems(form, parentKey);

    var addData = null;

    if (children.length) {
      var childRes = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: children,
          sections: ['mini-cart']
        })
      });

      if (!childRes.ok) {
        throw new Error('Child products add failed');
      }

      addData = await childRes.json();
    }


    // -------------------------------------------------------------------------
    // 4. GET MINI CART SECTION
    // -------------------------------------------------------------------------
    // If there were no child products, we still need the refreshed
    // mini-cart HTML.
    // -------------------------------------------------------------------------
    if (!addData || !addData.sections) {
      var sectionRes = await fetch(
        cartAddUrl + '?sections=mini-cart',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [],
            sections: ['mini-cart']
          })
        }
      ).catch(function () {
        return null;
      });

      if (sectionRes && sectionRes.ok) {
        addData = await sectionRes.json();
      }
    }


    // -------------------------------------------------------------------------
    // 5. GET FINAL CART
    // -------------------------------------------------------------------------
    var cartData = await fetch(cartUrl, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch cart');
        }

        return response.json();
      })
      .catch(function () {
        return null;
      });


    // -------------------------------------------------------------------------
    // 6. ATTACH UPDATED MINI CART SECTION
    // -------------------------------------------------------------------------
    if (
      cartData &&
      addData &&
      addData.sections
    ) {
      cartData.sections = addData.sections;
    }


    // -------------------------------------------------------------------------
    // 7. REFRESH + OPEN CART DRAWER
    // -------------------------------------------------------------------------
    if (cartData) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: cartData
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cartData,
            openMiniCart: true
          }
        })
      );
    } else {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            openMiniCart: true
          }
        })
      );
    }


    // -------------------------------------------------------------------------
    // DONE
    // -------------------------------------------------------------------------
    // DO NOT click checkout.
    // DO NOT redirect.
    //
    // User stays on product page with the new cart drawer open.
    // -------------------------------------------------------------------------

  } catch (error) {
    console.error('[TMC BuyNow]', error);

  } finally {
    // Restore button
    delete submitter.dataset.tmcLoading;

    setLoading(form, submitter, false);

    // Recalculate grey/active appearance
    syncButton(form);
  }
}

    // ---- 5. Wire up each product form --------------------------------------
    function bind(form) {
      if (!form || form.__tmcBuyNowBound) return;
      if (!form.querySelector('.product-form__buy-now-button')) return;
      form.__tmcBuyNowBound = true;

      // Remember which button was clicked (event.submitter unreliable here)
      form.addEventListener('click', function (e) {
        var btn = e.target.closest('button[type="submit"], input[type="submit"], [is="loader-button"]');
        if (btn && form.contains(btn)) form.__tmcSubmitter = btn;
      }, true);

      // Intercept Buy Now submit before the theme/default handler runs
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter || form.__tmcSubmitter;
        var isBuyNow = submitter && submitter.getAttribute && submitter.getAttribute('data-open-cart-drawer') === 'true';
        if (!isBuyNow) return; // let Add to Cart behave normally
        e.preventDefault();
        e.stopImmediatePropagation();
        var res = validateFormOptions(form, true);
        if (!res.isValid) { if (res.firstInvalid) res.firstInvalid.focus(); return; }
        doBuyNow(form, submitter);
      }, true);

      // Keep Buy Now disabled until all required options are filled
      function update() { syncButton(form); }
      form.addEventListener('input', update);
      form.addEventListener('change', update);
      // Charm pickers change a hidden input via JS (no native event)
      form.addEventListener('click', update, true);
      form.addEventListener('variant:changed', function () { setTimeout(update, 60); });
      form.addEventListener('product:rerender', function () { setTimeout(update, 60); });
      update();
    }

    function init() {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(bind);
    }
    init();
    // Re-scan when content is stamped in (quick buy, variant re-render, etc.)
    if (!window.__tmcBuyNowObserver) {
      window.__tmcBuyNowObserver = new MutationObserver(init);
      window.__tmcBuyNowObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

